document.addEventListener('DOMContentLoaded', function() {
    // カラム表示切替
    const STORAGE_KEY = 'certAppVisibleColumns';
    const LOCKED_COLUMNS = [
        'branch', 'opening_year_month',
        'submission_status', 'recruitment_status',
        'application_date', 'certification_scheduled_date',
        'user_group'
    ];
    const DEFAULT_COLUMNS = [...LOCKED_COLUMNS];

    const toggleBtn = document.getElementById('toggle-columns-btn');
    const panel = document.getElementById('columns-panel');
    const checkboxes = document.querySelectorAll('.column-toggle:not([disabled])');

    // app.js はすべてのページで読み込まれる。認定申請一覧以外のページでは何もしない
    if (!toggleBtn || !panel) {
        return;
    }

    // パネル開閉
    toggleBtn.addEventListener('click', function() {
        const isHidden = panel.classList.contains('hidden');
        panel.classList.toggle('hidden');
        toggleBtn.textContent = isHidden ? '表示項目 ▲' : '表示項目 ▼';
    });

    // localStorageから設定を読み込み（なければデフォルト）
    function loadVisibleColumns() {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            const parsed = JSON.parse(saved);
            // 固定カラムを必ず含める
            LOCKED_COLUMNS.forEach(col => {
                if (!parsed.includes(col)) parsed.push(col);
            });
            return parsed;
        }
        return DEFAULT_COLUMNS;
    }

    // localStorageに設定を保存（固定カラムは常に含める）
    function saveVisibleColumns(columns) {
        LOCKED_COLUMNS.forEach(col => {
            if (!columns.includes(col)) columns.push(col);
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(columns));
    }

    // カラムの表示/非表示を適用
    function applyColumnVisibility(visibleColumns) {
        // 切替可能なチェックボックス
        checkboxes.forEach(cb => {
            const col = cb.dataset.col;
            const isVisible = visibleColumns.includes(col);
            cb.checked = isVisible;
            toggleColumn(col, isVisible);
        });
        // 固定カラムは常に表示
        LOCKED_COLUMNS.forEach(col => toggleColumn(col, true));
    }

    // 単一カラムの表示/非表示を切り替え
    function toggleColumn(col, visible) {
        const cells = document.querySelectorAll('[data-column="' + col + '"]');
        const display = visible ? '' : 'none';
        cells.forEach(cell => {
            cell.style.display = display;
        });
    }

    // 現在チェックされているカラムを取得
    function getCheckedColumns() {
        const columns = [];
        checkboxes.forEach(cb => {
            if (cb.checked) columns.push(cb.dataset.col);
        });
        return columns;
    }

    // チェックボックス変更イベント
    checkboxes.forEach(cb => {
        cb.addEventListener('change', function() {
            toggleColumn(this.dataset.col, this.checked);
            saveVisibleColumns(getCheckedColumns());
        });
    });

    // 全選択
    document.getElementById('select-all-columns').addEventListener('click', function() {
        const allColumns = [];
        checkboxes.forEach(cb => {
            cb.checked = true;
            allColumns.push(cb.dataset.col);
            toggleColumn(cb.dataset.col, true);
        });
        saveVisibleColumns(allColumns);
    });

    // 全解除（固定カラムは維持）
    document.getElementById('deselect-all-columns').addEventListener('click', function() {
        checkboxes.forEach(cb => {
            cb.checked = false;
            toggleColumn(cb.dataset.col, false);
        });
        saveVisibleColumns([]);
    });

    // 初期化：カラム表示を適用後、テーブルを表示
    applyColumnVisibility(loadVisibleColumns());
    const tableContainer = document.getElementById('table-container');
    if (tableContainer) {
        tableContainer.style.visibility = 'visible';
    }
});
